module.exports = __webpack_public_path__ + "img/4_Hills-01.7a16f5d6.png";